import React, { lazy, Suspense } from "react";
import NavBar from "@/components/sections/NavBar";
import Hero from "@/components/sections/Hero";
import Stats from "@/components/sections/Stats";

// Below the fold: lazy load so initial JS bundle stays minimal
const Showreel = lazy(() => import("@/components/sections/Showreel"));
const BrandsMarquee = lazy(() => import("@/components/sections/BrandsMarquee"));
const GroupPortfolio = lazy(() => import("@/components/sections/GroupPortfolio"));
const Experience = lazy(() => import("@/components/sections/Experience"));
const Skills = lazy(() => import("@/components/sections/Skills"));
const Productions = lazy(() => import("@/components/sections/Productions"));
const Education = lazy(() => import("@/components/sections/Education"));
const Footer = lazy(() => import("@/components/sections/Footer"));

// Lightweight placeholder, ensures continuity while chunks load
const Skeleton = () => <div className="min-h-[400px]" aria-hidden="true" />;

export default function Portfolio() {
  return (
    <main
      data-testid="portfolio-root"
      className="min-h-screen bg-[var(--bg-base)] text-white selection:bg-[var(--accent-primary)] selection:text-black"
    >
      <NavBar />
      <Hero />
      <Stats />
      <Suspense fallback={<Skeleton />}>
        <Showreel />
        <BrandsMarquee />
        <GroupPortfolio />
        <Experience />
        <Skills />
        <Productions />
        <Education />
        <Footer />
      </Suspense>
    </main>
  );
}
